import { z } from 'zod';
import { MemberPreferenceKeySchema, MemberPreferenceValueSchema } from '../identity/member-preferences.schemas';

// Per-operator key/value preference store (IMM-1074.1), the admin.immoos.ai twin of
// the member store. The operator is always the calling session's admin — never in
// the path. Key and value rules are the member store's, so the two cannot drift.
export const AdminPreferencePathParamsSchema = z.object({ key: MemberPreferenceKeySchema });

export const GetAdminPreferenceResponseSchema = z.object({ value: MemberPreferenceValueSchema.nullable() });
export type GetAdminPreferenceResponse = z.infer<typeof GetAdminPreferenceResponseSchema>;

export const SaveAdminPreferenceBodySchema = z.object({ value: MemberPreferenceValueSchema });
export const SaveAdminPreferenceResponseSchema = z.object({ value: MemberPreferenceValueSchema });
export type SaveAdminPreferenceResponse = z.infer<typeof SaveAdminPreferenceResponseSchema>;
